import React, { useState, useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Link } from 'react-router-dom';
import * as Scroll from 'react-scroll';

import HeaderLogoImgWhite from './Images/logo_white.svg'
import SideBar from './Common/SideBar';
import LanguageSelect from './Common/LanguageSelect';

import home_icon from './Images/home_icon.svg';
import we_icon from './Images/we_icon.svg';
import games_icon from './Images/games_icon.svg';
import gfi_icon from './Images/gfi_icon.svg';
import vision_icon from './Images/vision_icon.svg';
import partners_icon from './Images/partners_icon.svg';
import wallet_icon from './Images/wallet_icon.svg';

let ScrollLink = Scroll.Link;

const HeaderAni = keyframes`
  0% {
    height: 0px
  }
  50% {
    height: 80px;
  }
  100% {
    height: 60px;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: ${props => props.PageBoolean ? (props.HeaderScollo ? "fixed" : "absolute") : "fixed"};
  top: 0;
  left: 0;
  height: ${props => props.PageBoolean ? (props.HeaderScollo ? "60px" : "80px") : "60px"};
  width: 100%;
  background-color: ${props => props.PageBoolean ? (props.HeaderScollo ? "#000" : "transparent") : "#000"};
  animation: ${props => props.PageBoolean ? (props.HeaderScollo ? css`${HeaderAni} 0.3s linear` : "none") : "none"};
  z-index: 1000;
`

const SubContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: 1370px;
`

const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 40px;

  & a > img {
    height: 30px;
  }

  @media (max-width: 1410px) {
    margin-left: 40px;
  };
  @media (max-width: 920px) {
    margin-left: 20px;
  };
`

const TopMenu = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  /* margin-right: 40px; */

  & > a {
    margin-left: 40px;
    cursor: pointer;

    & > a > p {
      color: ${props => props.PageBoolean ? (props.HeaderScollo ? "#fff" : "#fff") : "#fff"};
      /* font-weight: 300; */
      font-size: 14px;

      &:hover {
        font-weight: 600;
      }

      & > span {
        font-family: 'Abhaya Libre';
        font-weight: 400;
      }
    }
    
    &:first-child {
      margin-left: 0;
    }
  }

  & > .active {
    
    & > a > p {
      color: ${props => props.PageBoolean ? (props.HeaderScollo ? "#fff" : "#000") : "#fff"};
      font-weight: 600;

      & > span {
        font-family: 'Abhaya Libre';
        font-weight: 400;
      }
    }
  }

  @media (max-width: 1170px) {
    display: none;
  };

  & > a > div:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 32px;
    border: 1px solid black;
    border-radius: 34px;
    font-size: 12px;
    font-weight: 300;

    & p {
      color: black;
    }
  }

  & > a > div:last-child:hover {
    background-color: black;

    & p {
      color: white;
    }
  }
`
const SideNav = styled.div`
  display: ${props => props.pathname === "/clinics" ? "none" : "flex"};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
  width: 60px;
  height: 30px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  
  & > svg {
    z-index: 100;
  }

  & > div {
    z-index: 100;
    height: 2px;
    width: 17px;
    border-radius: 2px;
    background-color: ${props => props.PageBoolean ? (props.HeaderScollo ? "#fff" : "#fff") : "#fff"};;
  }

  div + div {
    margin-top: 3px;
  }

  @media (min-width: 1170px) {
    display: none;
  };
`

const Header = ({ setSideMenuHandler, sideState, language, Translation, TranslationHandler, KoreaLanguageHandler, EnglishLanguageHandler, pathname }) => {
  const [HeaderScollo, setHeaderScollo] = useState(false);
  const [PageBoolean, setPageBoolean] = useState(false);
  const menuState = [
    { text: 'Home', icon: home_icon },
    { text: 'We', icon: we_icon },
    { text: 'Games', icon: games_icon },
    { text: 'G-Fi', icon: gfi_icon },
    { text: 'G-Wallet', icon: wallet_icon },
    { text: 'Vision', icon: vision_icon },
    { text: 'Partners', icon: partners_icon },
  ]

  const PageBooleanHandler = () => {
    const PathName = window.location.pathname;
    if (PathName === "/") {
      setPageBoolean(true)
    } else {
      setPageBoolean(false)
    }
  }

  useEffect(() => {
    PageBooleanHandler()
    document.addEventListener('scroll', () => {
      const ScrollY = window.pageYOffset
      if (ScrollY > 80) {
        setHeaderScollo(true)
      } else {
        setHeaderScollo(false);
      };
    });
  }, []);

  return (
    <Container HeaderScollo={HeaderScollo} PageBoolean={PageBoolean}>
      <SubContainer>
        <Logo>
          <ScrollLink
            activeClass="active"
            to="HOME"
            spy={true}
            smooth={true}
            offset={-60}
            duration={500}
          >
            <Link to="/">
              {
                PageBoolean && HeaderScollo ?
                  <img alt="" src={HeaderLogoImgWhite} />
                  :
                  <img alt="" src={HeaderLogoImgWhite} />
              }
            </Link>
          </ScrollLink>
        </Logo>
        <TopMenu PageBoolean={PageBoolean} HeaderScollo={HeaderScollo}>
          {
            menuState.map((item, index) => {
              return (
                <>
                  {
                    index !== 0 &&
                      <ScrollLink
                        activeClass="active"
                        to={item.text}
                        spy={true}
                        smooth={true}
                        offset={-60}
                        duration={500}
                      >
                        <Link to="/">
                          <p>{item.text}</p>
                        </Link>
                      </ScrollLink>
                  }
                </>
              )
            })
          }
        </TopMenu>
        <LanguageSelect
          language={language}
          Translation={Translation}
          TranslationHandler={TranslationHandler}
          KoreaLanguageHandler={KoreaLanguageHandler}
          EnglishLanguageHandler={EnglishLanguageHandler}
        />
        <SideNav onClick={setSideMenuHandler} pathname={pathname} PageBoolean={PageBoolean} HeaderScollo={HeaderScollo}>
          {
            !sideState ?
            <>
              <div></div>
              <div></div>
              <div></div>
            </>
            :
            <svg width="15" height="15" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8501 2.94967C10.1165 0.215997 5.68431 0.215996 2.95064 2.94967C0.216973 5.68334 0.216973 10.1155 2.95064 12.8492L43.1512 53.0497L3.05025 93.1507C0.316582 95.8843 0.316582 100.317 3.05025 103.05C5.78392 105.784 10.2161 105.784 12.9497 103.05L53.0507 62.9492L93.0511 102.95C95.7848 105.683 100.217 105.683 102.951 102.95C105.684 100.216 105.684 95.7838 102.951 93.0502L62.9502 53.0497L103.05 12.9497C105.784 10.216 105.784 5.78384 103.05 3.05017C100.317 0.3165 95.8844 0.316498 93.1508 3.05017L53.0507 43.1502L12.8501 2.94967Z" fill="#fff" />
            </svg>
          }
        </SideNav>
      </SubContainer>
      <SideBar
        sideState={sideState}
        menuState={menuState}
        closeOnPress={setSideMenuHandler}
      />
    </Container>
  );
};

export default Header; 